// Privacy-safe analytics wrapper.
//
// Rule: NEVER send anything a person wrote — no message content, conversation
// text, journey entries, values, or lingering questions. Events carry only
// counts, timestamps, and IDs. Each helper below hand-picks its properties so
// free-text can never leak through, even if a caller passes extra fields.

function capture(event, properties) {
  if (typeof window === "undefined" || !window.posthog) return;
  try {
    window.posthog.capture(event, properties);
  } catch (_) {
    // analytics must never break the app
  }
}

export const analytics = {
  conversationStarted: ({ mode, domain }) =>
    capture("conversation_started", { mode, domain: domain ?? null }),

  messageSent: ({ conversationId, messageIndex }) =>
    capture("message_sent", {
      conversation_id: conversationId,
      message_index: messageIndex,
    }),

  conversationEnded: ({ messageCount }) =>
    capture("conversation_ended", { message_count: messageCount }),

  journeyViewed: () => capture("journey_viewed", {}),

  subscriptionStarted: () => capture("subscription_started", {}),
};
